import { render, staticRenderFns } from "./RegisterSuccess.vue?vue&type=template&id=289a1d36&scoped=true"
import script from "./RegisterSuccess.vue?vue&type=script&lang=js"
export * from "./RegisterSuccess.vue?vue&type=script&lang=js"
import style0 from "./RegisterSuccess.vue?vue&type=style&index=0&id=289a1d36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289a1d36",
  null
  
)

export default component.exports